import $ from 'jquery';

// hack to make the buttons render when Funnelkit express checkout is being used. Funnelkit uses a MutationObserver
// to know when the buttons have been rendered. Adding the <span> element triggers the MutationObserver callback.
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        $('.wc-stripe-checkout-banner-gateway.StripeElement').each(function (i, e) {
            $(e).append('<span style="display:none;"></span>');
        });
    }, 500);
})